module.exports = __webpack_public_path__ + "static/media/0025_IMG_LE_SOL_CARRELAGE_EXISTANT.15f3bfaa.webp";